// usePreloadIcons.js
import { useEffect } from 'react';

// Firebase
import { collection, getDocs } from 'firebase/firestore';
import { collections, db } from 'firebaseConfig';

// Cache
import { readIconsSnapshot, writeIconsSnapshot } from 'services/icons/IconsCacheService';

// Context
import { useIcons } from 'context/IconsContext';

const normalizeIcon = (docSnap) => {
  const data = docSnap.data() || {};
  const key = data.key;
  if (!key) return null;

  return {
    ...data,
    key,
  };
};

const usePreloadIcons = ({ enabled = true } = {}) => {
  const { iconsByKey, setIconsByKey } = useIcons();

  useEffect(() => {
    let isMounted = true;

    if (!enabled || iconsByKey !== null) return undefined;

    const loadIcons = async () => {
      try {
        const cached = await readIconsSnapshot();
        if (isMounted && cached && Object.keys(cached).length > 0) {
          setIconsByKey(cached);
          return;
        }

        const snap = await getDocs(collection(db, collections.icons));
        const nextMap = {};

        snap.forEach((docSnap) => {
          const icon = normalizeIcon(docSnap);
          if (!icon) return;
          nextMap[icon.key] = icon;
        });

        if (isMounted) setIconsByKey(nextMap);
        writeIconsSnapshot(nextMap);
      } catch (error) {
        console.error('[usePreloadIcons] Failed to load icons:', error);
        if (isMounted && iconsByKey === null) setIconsByKey({});
      }
    };

    loadIcons();

    return () => {
      isMounted = false;
    };
  }, [enabled, iconsByKey, setIconsByKey]);
};

export default usePreloadIcons;
